var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news container"},[_c('div',{staticClass:"news__container"},[_c('b-table',{attrs:{"striped":"","fields":_vm.fields,"items":_vm.items},scopedSlots:_vm._u([{key:"cell(title)",fn:function(row){return [_c('a',{attrs:{"href":row.item.link,"target":"_blank"}},[_vm._v(" "+_vm._s(row.item.title)+" ")])]}}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }